module.exports = __webpack_public_path__ + "img/2019_Xingyi.3b9d3c95.png";